import { t } from "../../../../../../../utils/i18n";
import React from "react";
interface Props {
  file: any;
}

const DisplayFile: React.FC<Props> = ({ file }) => (
  <>
    {file ? (
      <>
        {file.type.startsWith("image") ? (
          <span>
            <a
              href={URL.createObjectURL(file)}
              target="_blank"
              rel="noopener noreferrer"
              className="card-activate-link"
            >
              <i className="fa fa-link"></i>
              {" "}
              {t("cards.request_form.preview_image")}
            </a>
          </span>
        ) : (
          <span>
            <br />
            <a
              href={URL.createObjectURL(file)}
              target="_blank"
              rel="noopener noreferrer"
              className="card-activate-link"
            >
              <i className="fa fa-link"></i>
              {" "}
              {t("cards.request_form.preview_pdf")}
            </a>
          </span>
        )}
      </>
    ) : (
      <span>{t("cards.request_form.no_file_uploaded")}</span>
    )}
  </>
);

export default DisplayFile;
